import { render, staticRenderFns } from "./WordList.vue?vue&type=template&id=ef9eea3e&scoped=true&"
import script from "./WordList.vue?vue&type=script&lang=js&"
export * from "./WordList.vue?vue&type=script&lang=js&"
import style0 from "./WordList.vue?vue&type=style&index=0&id=ef9eea3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9eea3e",
  null
  
)

export default component.exports